import HyperDiv from "components/ProjectNonSpecificComponents/Elements/HyperDiv/HyperDiv"
import Whitespace from "components/ProjectNonSpecificComponents/Elements/Whitespace"
import { TOnClick } from "components/ProjectSpecificComponents/Interfaces/GlobalInterface"
import React, { Ref, useEffect, useMemo, useRef, useState } from "react"
import styled from "styled-components"
import Icon from "../../Global/atoms/Icons/Icon/Icon"
import { TIconKey } from "../../Global/atoms/Icons/Icon/Interfaces"
import concatWithSpaces from "components/ProjectNonSpecificComponents/Functions/concatWithSpaces"
import {
	TInternalFormName,
	TPTKMInternalFormName,
} from "components/ProjectSpecificComponents/Interfaces/AdminInterface"
import { useStore } from "components/ProjectSpecificComponents/Contexts/GlobalStoreContext"
import { useInView } from "react-intersection-observer"
import { observer } from "mobx-react"

interface Props {
	iconKey: TIconKey
	textHidden?: boolean
	alignedRight?: boolean
	children?: React.ReactNode
	onClick?: TOnClick
	sectionKey: TInternalFormName | TPTKMInternalFormName
}

const SideNavItem = observer(
	({ iconKey, textHidden = false, alignedRight = false, children, onClick, sectionKey }: Props) => {
		const store = useStore()

		return (
			<HyperDiv
				className={concatWithSpaces(
					onClick ? "pointer" : "",
					"hover-highlight",
					store.sectionIsInView[sectionKey] ? " bg-gray-100" : ""
				)}
				direction="row"
				padding="0.8rem"
				margin="0.2rem"
				centeredY
				alignedRight={alignedRight}
				alignedLeft={!alignedRight}
				onClick={onClick}
				style={{ borderRadius: 5 }}
			>
				<HyperDiv doesNotShrink>
					<Icon width={24} height={24} iconKey={iconKey} iconColor="var(--muddy-puddle-gray)" />
				</HyperDiv>
				{!textHidden && (
					<>
						<Whitespace h x="0.3" />
						<CustomText className="hide-overflown-text-nowrap" children={children} />
					</>
				)}
			</HyperDiv>
		)
	}
)

export default SideNavItem

const CustomText = styled.div`
	color: var(--muddy-puddle-gray);
	font-size: 14px;
`
